import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchPackageService } from '../../../services/search-package.service';

@Component({
  selector: 'app-deep-cleaning-log-modal',
  templateUrl: './deep-cleaning-log-modal.component.html',
  styleUrls: ['./deep-cleaning-log-modal.component.less']
})
export class DeepCleaningLogModalComponent implements OnInit {
  @Input() searchEntryId!: number;

  attemptNumber: number = 1;
  timestampLocal: string = '';
  note: string = '';
  qualityChecked: boolean = false;

  loading = false;
  error: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private searches: SearchPackageService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.searches.getDeepCleaningPreview(this.searchEntryId).subscribe({
      next: (preview: any) => {
        this.attemptNumber = preview.attemptNumber ?? 1;
        this.timestampLocal = preview.defaultTimestampUtc
          ? this.toLocalDatetime(preview.defaultTimestampUtc)
          : this.toLocalDatetime(new Date().toISOString());
        this.loading = false;
      },
      error: () => {
        this.attemptNumber = 1;
        this.timestampLocal = this.toLocalDatetime(new Date().toISOString());
        this.loading = false;
      }
    });
  }

  toLocalDatetime(iso: string): string {
    const d = new Date(iso);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  save(): void {
    this.error = null;
    if (!this.note || !this.timestampLocal) {
      this.error = 'Note and timestamp are required.';
      return;
    }
    this.loading = true;
    const utcIso = new Date(this.timestampLocal).toISOString();
    const payload = {
      searchEntryId: this.searchEntryId,
      timestamp: utcIso,
      note: this.note,
      qualityChecked: this.qualityChecked
    };
    this.searches.logDeepCleaning(payload).subscribe({
      next: () => {
        this.activeModal.close({ saved: true });
      },
      error: (err) => {
        console.error('Error saving log:', err);
        this.error = 'Failed to save log.';
        this.loading = false;
      }
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}